import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import authService from "../services/discordAuth";
import { useTranslation } from "react-i18next";
import "./UserProfile.css";

function UserProfile() {
  const { t, i18n } = useTranslation();
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 70,
    left: 0,
  });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const checkUser = () => {
      if (authService.isAuthenticated()) {
        setUser(authService.getUser());
      } else {
        setUser(null);
      }
    };

    checkUser();

    // Opcional: ouvir mudanças no storage para outros casos
    window.addEventListener("storage", checkUser);

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleDropdown = () => {
    if (!showDropdown && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownWidth = 250;

      let leftPosition = rect.right - dropdownWidth;

      if (leftPosition < 10) leftPosition = 10;
      if (leftPosition + dropdownWidth > window.innerWidth - 10) {
        leftPosition = window.innerWidth - dropdownWidth - 10;
      }

      setDropdownPosition({
        top: rect.bottom + 8,
        left: leftPosition,
      });
    }

    setShowDropdown(!showDropdown);
  };

  const handleLogin = () => authService.login();

  const handleLogout = () => {
    authService.logout();
    setUser(null);
    setShowDropdown(false);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  if (!user) {
    return (
      <button className="btn btn-outline-light btn-sm" onClick={handleLogin}>
        {t("userProfile.login")}
      </button>
    );
  }

  return (
    <div className="user-profile-container d-none d-md-none d-lg-block">
      <button ref={buttonRef} className="user-profile-button" onClick={handleToggleDropdown}>
        <img
          src={
            user.avatar
              ? `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}${user.avatar.startsWith("a_") ? ".gif" : ".png"}?size=256`
              : `https://cdn.discordapp.com/embed/avatars/${parseInt(user.id) % 5}.png`
          }
          alt={user.username}
          className="user-avatar"
        />
        <span className="user-name">{user.username}</span>
        <span className="dropdown-arrow">{showDropdown ? "▲" : "▼"}</span>
      </button>

      {showDropdown && (
        <div
          className="user-dropdown"
          ref={dropdownRef}
          style={{
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
          }}
        >
          <div className="dropdown-header">
            <img
              src={
                user.avatar
                  ? `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}${user.avatar.startsWith("a_") ? ".gif" : ".png"}?size=256`
                  : `https://cdn.discordapp.com/embed/avatars/${parseInt(user.id) % 5}.png`
              }
              alt={user.username}
              className="dropdown-avatar"
            />
            <div className="dropdown-user-info">
              <div className="dropdown-username">{user.username}</div>
              <div className="dropdown-discriminator">
                {t("userProfile.userId")} {user.id}
              </div>
            </div>
          </div>

          <div className="dropdown-divider"></div>

          <div className="user-dropdown-menu">
            <Link to="/profile" className="dropdown-item" onClick={() => setShowDropdown(false)}>
              <span>👤</span> {t("userProfile.myProfile")}
            </Link>
            <Link to="/add-bot" className="dropdown-item" onClick={() => setShowDropdown(false)}>
              <span>➕</span> {t("userProfile.addBot")}
            </Link>
            <Link to="/settings" className="dropdown-item" onClick={() => setShowDropdown(false)}>
              <span>⚙️</span> {t("userProfile.settings")}
            </Link>
          </div>

          <div className="dropdown-divider"></div>

          <div className="language-switcher-dropdown">
            <div className="language-switcher-header">
              <span>🌐</span> {t("userProfile.language")}
            </div>
            <div className="language-options">
              <button className={`lang-option ${i18n.language === "pt" ? "active" : ""}`} onClick={() => changeLanguage("pt")}>
                PT-BR
              </button>
              <button className={`lang-option ${i18n.language === "en" ? "active" : ""}`} onClick={() => changeLanguage("en")}>
                EN-US
              </button>
            </div>
          </div>

          <div className="dropdown-divider"></div>

          <button className="dropdown-item logout-btn" onClick={handleLogout}>
            <span>🚪</span> {t("userProfile.logout")}
          </button>
        </div>
      )}
    </div>
  );
}

export default UserProfile;
